import {
  GET_MENU_SERIES_USER_BOOKMARKS_SUCCESS,
  GET_INFO_SECTION_USER_BOOKMARKS_SUCCESS,
  GET_USER_BOOKMARKS_ERROR,
  CLEAR_INFO_SECTION_USER_BOOKMARK,
  GET_INFO_SECTION_BOOKMARKS_INIT,
  GET_MENU_SERIES_BOOKMARKS_INIT,
} from './constants';
import { fetchUserBookmars } from '../../services/bookmark.service';

export const getUserBookmarks = (groupIds, bookmarkType, seasonId) => async (
  dispatch,
  getState,
) => {
  const getUserBookmarksRequested = () => ({
    type:
      bookmarkType === 'infoSectionType'
        ? GET_INFO_SECTION_BOOKMARKS_INIT
        : GET_MENU_SERIES_BOOKMARKS_INIT,
  });

  const getUserBookmarksFailed = error => ({
    type: GET_USER_BOOKMARKS_ERROR,
    error,
  });

  dispatch(getUserBookmarksRequested());
  const params = {
    group_id: Array.isArray(groupIds) ? groupIds.join(',') : groupIds,
    user_hash: getState().user.userhash,
    lasttouch: localStorage.getItem('lasttouchSeen'),
  };

  return fetchUserBookmars(params)
    .then(({ data: { response: { groups } } }) => {
      const bockmarksList = groups.map(g => ({ id: g.id, vistime: g.vistime }));
      if (bookmarkType === 'menuSeriesType') {
        dispatch({
          type: GET_MENU_SERIES_USER_BOOKMARKS_SUCCESS,
          groups: bockmarksList,
          seasonId,
        });
      } else if (bookmarkType === 'infoSectionType') {
        dispatch({
          type: GET_INFO_SECTION_USER_BOOKMARKS_SUCCESS,
          groups: bockmarksList,
        });
      }
    })
    .catch(error => {
      dispatch(getUserBookmarksFailed(error));
    });
};

export const clearInfoSectionBookmark = () => dispatch => {
  dispatch({
    type: CLEAR_INFO_SECTION_USER_BOOKMARK,
  });
};
